const ElectricianServicesData = [
  {
    id: 1,
    title: "Residential Electrician Service",
    image: "/assets/ElectronincServices/Electrician Services1.jpg",
    image2: "/assets/ElectronincServices/ElectricianServices2.jpeg",
    image3: "/assets/ElectronincServices/Electroninc Services.jpg",
    shortDescription: "Expert electrical solutions for your home.",
    description:
      "Our Residential Electrician Service ensures your home’s electrical systems are safe and efficient. We provide a range of services, from installations to repairs, tailored to residential needs.",
    description1:
      "Whether you need new lighting fixtures, wiring upgrades, or troubleshooting, our skilled electricians handle it all with precision and care.",
    description2:
      "We prioritize safety and comfort, ensuring your home remains powered without disruptions. All services adhere to industry standards and best practices.",
    benefits: [
      "Safe and reliable home electrical solutions.",
      "Experienced and licensed electricians.",
      "Quick response to emergencies.",
      "Affordable pricing for residential clients.",
      "Energy-efficient solutions for lower bills.",
      "Guaranteed satisfaction and safety.",
    ],
  },
  {
    id: 2,
    title: "Commercial Electrician Service",
    image: "/assets/ElectronincServices/Commercial Electrician Service.jpg",
    image2: "/assets/ElectronincServices/Commercial Electrician Service1.jpeg",
    image3: "/assets/ElectronincServices/Commercial Electrician Service3.jpg",
    shortDescription: "Reliable electrical solutions for commercial spaces.",
    description:
      "Our Commercial Electrician Service is designed to meet the unique requirements of businesses. From large-scale installations to routine maintenance, we have the expertise to handle it all.",
    description1:
      "We specialize in power distribution, lighting systems, and electrical panel upgrades for offices, retail spaces, and industrial buildings.",
    description2:
      "Our team ensures minimal disruption to your operations while delivering quality electrical solutions. Emergency services are also available for unexpected power issues.",
    benefits: [
      "Custom electrical solutions for businesses.",
      "Energy-efficient installations and upgrades.",
      "Expertise in handling commercial-grade systems.",
      "Minimizes downtime during repairs.",
      "Compliant with safety and industry standards.",
      "24/7 emergency support for businesses.",
    ],
  },
  {
    id: 3,
    title: "Industrial Electrician Service",
    image: "/assets/ElectronincServices/Industrial Electrician Service.jpg",
    image2: "/assets/ElectronincServices/Industrial Electrician Service1.jpg",
    image3: "/assets/ElectronincServices/Industrial Electrician Service3.jpg",
    shortDescription: "Comprehensive electrical services for industries.",
    description:
      "Our Industrial Electrician Service provides tailored solutions for factories, plants, and warehouses. From large-scale installations to equipment maintenance, we ensure your operations run smoothly.",
    description1:
      "We handle high-voltage systems, motor controls, and power distribution with precision and expertise. Our team ensures compliance with industrial safety standards.",
    description2:
      "With proactive maintenance plans, we minimize downtime and prevent costly disruptions. Our electricians are equipped to handle complex industrial electrical systems.",
    benefits: [
      "Specialized in industrial electrical systems.",
      "High-quality materials and advanced tools.",
      "Proactive maintenance for uninterrupted operations.",
      "Adheres to strict industrial safety regulations.",
      "Quick response for urgent repairs.",
      "Custom solutions for large-scale projects.",
    ],
  },
  {
    id: 4,
    title: "Emergency Electrician Service",
    image: "/assets/ElectronincServices/Emergency Electrician Service.jpeg",
    image2: "/assets/ElectronincServices/Emergency Electrician Service2.jpeg",
    image3: "/assets/ElectronincServices/Emergency Electrician Service3.jpeg",
    shortDescription: "24/7 emergency electrical repairs and solutions.",
    description:
      "Our Emergency Electrician Service provides immediate assistance for unexpected electrical issues. Available 24/7, our team ensures your safety and restores power quickly.",
    description1:
      "From power outages to electrical faults, we diagnose and resolve problems efficiently. Our electricians are equipped to handle emergencies with minimal disruption.",
    description2:
      "We prioritize urgent situations and ensure quick response times. Our goal is to restore power and safety to your property as soon as possible.",
    benefits: [
      "Available 24/7 for emergencies.",
      "Fast and efficient problem resolution.",
      "Reduces downtime and safety risks.",
      "Experienced electricians on call.",
      "Equipped for all types of electrical emergencies.",
      "Affordable and transparent pricing.",
    ],
  },
  {
    id: 5,
    title: "Smart Home Electrician Service",
    image: "/assets/ElectronincServices/Smart Home Electrician Service.jpeg",
    image2: "/assets/ElectronincServices/Smart Home Electrician Service2.webp",
    image3: "/assets/ElectronincServices/Smart Home Electrician Service3.jpeg",
    shortDescription: "Expert electrical solutions for smart home systems.",
    description:
      "Our Smart Home Electrician Service helps you integrate and maintain modern smart home technologies. From automation to smart lighting, we ensure seamless connectivity.",
    description1:
      "We specialize in installing and configuring smart home devices such as security systems, thermostats, and voice-controlled lighting.",
    description2:
      "Our electricians provide support for upgrades and troubleshooting, ensuring your smart home operates efficiently and securely.",
    benefits: [
      "Specialized in smart home technologies.",
      "Seamless integration of devices.",
      "Enhances home security and convenience.",
      "Energy-efficient solutions for smart homes.",
      "Expert troubleshooting and upgrades.",
      "Personalized solutions for smart living.",
    ],
  },
];

export default ElectricianServicesData;
